<template>
<div class="content-body tenant-settings">
    <!-- <div class="" style="background: red ;display: none"> -->
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="审批单号:">
                <el-input size="small" v-model="dataForm.rfqAuditCode" placeholder="审批单号" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="审批名称:">
                <el-input size="small" v-model="dataForm.rfqAuditName" placeholder="审批名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="审批单状态:">
                <el-select size="small" v-model="dataForm.rfqAuditStatus" placeholder="请选择状态" clearable @change="getDataList">
                    <el-option v-for="item in AUDIT_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="RFQ编码:">
                <el-input size="small" v-model="dataForm.rfqCode" placeholder="RFQ编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <!-- <el-form-item label="车型:">
                <el-input size="small" v-model="dataForm.carType" placeholder="车型" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="定点供应商:">
                <el-input size="small" v-model="dataForm.supplierId" placeholder="定点供应商" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="类型:">
                <el-select size="small" v-model="dataForm.orderType" placeholder="请选择类型" clearable @change="getDataList">
                    <el-option v-for="item in ORDER_TYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sourcing:audit:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建审批单
                </el-button> -->
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
                <el-table-column type="index" width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="rfqCode" header-align="center" align="center" label="RFQ编码" width="150">
                </el-table-column>
                <el-table-column prop="rfqStatus" header-align="center" align="center" label="RFQ状态" width="150">
                    <template slot-scope="scope">
                        {{getRFQ_STATUS_VALUE(scope.row.rfqStatus)}}
                    </template>
                </el-table-column>
                <el-table-column prop="rfqAuditCode" header-align="center" align="left" label="审批单编码" width="150">
                </el-table-column>
                <el-table-column prop="rfqAuditName" header-align="center" align="left" label="审批单名称" width="200">
                </el-table-column>
                <!-- (新品 B点) -->
                <el-table-column prop="rfqAuditType" header-align="center" align="center" label="审批单类型" width="150">
                    <template slot-scope="scope">
                        {{getAuditValue(scope.row.rfqAuditType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="rfqAuditStatus" header-align="center" align="center" label="审批单状态" width="150">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.rfqAuditStatus)">
                            {{scope.row.rfqAuditStatus}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="sourceType" header-align="center" align="center" label="寻源申请类型" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sourceType=='1'" >议标</span>
                        <span v-if="scope.row.sourceType=='0'" >招标</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="partCode" header-align="center" align="left" label="零件编码" width="150">
            </el-table-column>
            <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
            </el-table-column> -->
                <!-- <el-table-column prop="supplierCount" header-align="center" align="right" label="定厂供应商数量" width="150">
                </el-table-column>-->
                <el-table-column prop="rfqAuditDate" header-align="center" align="center" label="审批时间" width="150">
                </el-table-column>
                <!-- <el-table-column prop="carType" header-align="center" align="left" label="车型" width="120">
            </el-table-column> -->
                <!-- <el-table-column prop="rfqSupplierName" header-align="center" align="left" label="定点供应商" width="120">
            </el-table-column> -->
                <!-- <el-table-column prop="partPrice" header-align="center" align="right" label="部件价格(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="workingEquipmentMoney" header-align="center" align="right" label="工装投入(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="amortizationMoney" header-align="center" align="right" label="摊销金额(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="totalCost" header-align="center" align="right" label="全部成本(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="targetCost" header-align="center" align="right" label="目标成本(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="oneCarCost" header-align="center" align="right" label="单车用量(PC)" width="120">
            </el-table-column>
            <el-table-column prop="totalCarCost" header-align="center" align="right" label="单车全部成本(RMB)" width="150">
            </el-table-column> -->
                <el-table-column prop="pic" header-align="center" align="center" width="120" label="当前流程图示">
                    <template slot-scope="scope">
                        <el-link :disabled="scope.row.rfqAuditStatus === '流程结束' || scope.row.rfqAuditStatus === '已选定'" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="createBy" header-align="center" align="center" label="审批历史" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="doHistory(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="left" width="210" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:editbutton')" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:auditbutton')" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            审批
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:deletebutton')" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:editbutton')" size="small" @click="exportData(scope.row)" icon="el-icon-edit">
                            导出
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <audit-add-or-update v-if="auditAddOrUpdateVisible" ref="AuditAddOrUpdate" @refreshDataList="getDataList"></audit-add-or-update>

        <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
            <div v-for="str in historyList" :key="str">
                <el-descriptions :title="str.executeTime">
                    <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
                    <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
                    <el-descriptions-item label="原因" v-if="str.executeName == '不同意'">{{rejectReason}}</el-descriptions-item>
                </el-descriptions>
                <el-divider></el-divider>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="showViewer" width="80%" title="流程图">
            <el-image :src="diagramUrl" style="margin-bottom: 120px;">
            </el-image>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    getAuditList,
    deleteAudit,
    exportNewAudit,
    exportAudit
    // list
} from '@/controller/audit'
import {
    getRFQDetail
    // list
} from '@/controller/rfq'
import {
    listAllStatus,
    getProcessDiagramCurrent,
    listCommentHistory
} from '@/controller/workflow'
import {
    getLabelByValue,
    AUDIT_STATUS,
    getAuditValue,
    getRFQ_STATUS_VALUE,
    getTechnicalValue
} from '@/utils/const'

import AuditAddOrUpdate from './audit-add-or-update'
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                rfqAuditCode: '',
                rfqAuditCode: '',
                carType: '',
                supplierId: '',
            },
            getLabelByValue: getLabelByValue,
            getAuditValue: getAuditValue,
            getRFQ_STATUS_VALUE: getRFQ_STATUS_VALUE,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            auditAddOrUpdateVisible: false,
            // 审批历史
            drawer: false,
            // 审批列表
            historyList: [],
            showViewer: false,
            diagramUrl: '',
            rejectReason: '',
            AUDIT_STATUS: AUDIT_STATUS,
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },

    components: {
        AuditAddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            getAuditList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm
                // 'partCode': this.dataForm.partCode,
                // 'partName': this.dataForm.partName,
                // 'carType':this.dataForm.carType,
                // 'supplierId':this.dataForm.supplierId,
                // 'partPrice':this.dataForm.partPrice,
                // 'workingEquipmentMoney':this.dataForm.workingEquipmentMoney,
                // 'amortizationMoney':this.dataForm.amortizationMoney,
                // 'totalCost':this.dataForm.totalCost,
                // 'targetCost':this.dataForm.targetCost,
                // 'oneCarCost':this.dataForm.oneCarCost,
                // 'totalCarCost':this.dataForm.totalCarCost,
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    for(let key in this.dataList){
                         if(this.dataList[key].technicalId != null) {
                             getRFQDetail({}, this.dataList[key].rfqId).then((data) => {
                                if (data && data.code === "00") {
                                    this.dataList[key].sourceType = data.body.sourceType;
                                }
                            })
                        }
                    }
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.auditAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.AuditAddOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            // console.log(row, '新建')
            this.auditAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.AuditAddOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                debugger
                deleteAudit({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 审批历史
        doHistory(row) {
            this.historyList = []
            this.rejectReason = row.unQuoteReason
            listCommentHistory({
                'workflowId': row.workflowId
            }).then(data => {
                if (data && data.code === '00') {
                    this.historyList = data.body
                } else {
                    this.$message.error(data.msg)
                }
            })
            this.drawer = true

        },
        viewDiagram(id) {
            getProcessDiagramCurrent({
                id: id
            }).then(data => {
                this.diagramUrl = data.body
                this.showViewer = true
            })
        },
        rfqAuditStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(AUDIT_STATUS, value)
        },

        exportData(rec) {
            exportNewAudit(rec).then(data => {
                if (data && data.code === '00') {

                    console.log(data)
                    this.readAsBinaryString(data.body)
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            // this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        readAsBinaryString(data) {
           // alert(JSON.stringify(data))
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '草稿':
                    className = "text-primary"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        },
    }
}
</script>
